"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.acMobileFeatures = void 0;
const compare_versions_1 = require("compare-versions");
const acMobileFeatures = () => {
    const acMobileContextParser = () => {
        if (typeof window === "undefined")
            return false;
        const initialContext = window.initialContext;
        const serviceDetailsSessionStorage = sessionStorage.getItem("serviceDetails");
        if (serviceDetailsSessionStorage) {
            return JSON.parse(serviceDetailsSessionStorage);
        }
        else {
            return initialContext;
        }
    };
    const getVersion = () => { var _a; return (_a = acMobileContextParser()) === null || _a === void 0 ? void 0 : _a.mobileAppVersion; };
    const isLoggedIn = () => { var _a; return !!((_a = acMobileContextParser()) === null || _a === void 0 ? void 0 : _a.isLoggedIn); };
    const isNativeApp = () => { var _a; return !!((_a = acMobileContextParser()) === null || _a === void 0 ? void 0 : _a.isNativeApp); };
    const servicingEnabled = () => isNativeApp() && (0, compare_versions_1.compare)(getVersion(), "2.1.20", ">=");
    const valuationsEnabled = () => isNativeApp() && (0, compare_versions_1.compare)(getVersion(), "2.1.18", ">=");
    const nativeLocationAllowed = () => isNativeApp() && (0, compare_versions_1.compare)(getVersion(), "2.1.22", ">=");
    const nativeSharingAllowed = () => isNativeApp() && (0, compare_versions_1.compare)(getVersion(), "2.1.24", ">=");
    const shortlistEnabled = () => isNativeApp() && (0, compare_versions_1.compare)(getVersion(), "3.2.7", ">=");
    return {
        isLoggedIn,
        isNativeApp,
        getVersion,
        acMobileContextParser,
        servicingEnabled,
        valuationsEnabled,
        nativeLocationAllowed,
        nativeSharingAllowed,
        shortlistEnabled
    };
};
exports.acMobileFeatures = acMobileFeatures;
//# sourceMappingURL=ac-mobile-features.js.map